/*
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:14
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-03-06 11:50:54
 * @FilePath: \xypt-vue\src\api\interface\personCenter.js
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
 */
import axios from '../api' // 倒入 api
export const personCenter = {
  // 企业详情
  selectOrgInfo: data => {
    return axios({
      url: '/huizb-app/orgSearchTYC/selectOrgBasicInfoFromDatabase',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 上链记录
  getRepchainDatalist: data => {
    return axios({
      url: '/huizb-app/appUser/getRepchainDatalist',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 报告记录
  getMyAllReportRecordList: data => {
    return axios({
      url: '/huizb-app/reportRecord/getMyAllReportRecordList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 订单列表
  getMyAllTypeOrderList: data => {
    return axios({
      url: '/huizb-app/myOrder/getMyAllTypeOrderList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 申请发票
  applyInvoice: data => {
    return axios({
      url: '/huizb-app/myOrder/applyInvoice',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 取消订单
  cancelOrder: (data, url) => {
    return axios({
      url: url,
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 校验结果
  checkoutOrgFourElement: (data, url) => {
    return axios({
      url: '/huizb-app/order/checkoutOrgFourElement',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 校验结果
  updateOrgCreditReportPromiseBook: (data, url) => {
    return axios({
      url: '/huizb-app/myOrder/updateOrgCreditReportPromiseBook',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 我的同事
  selectMyColleague: data => {
    return axios({
      url: '/huizb-app/myColleague/selectMyColleague',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 搜索同事
  searchColleague: data => {
    return axios({
      url: '/huizb-app/myColleague/searchColleague',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 添加同事
  addInviteColleague: data => {
    return axios({
      url: '/huizb-app/myColleague/addInviteColleague',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 权限转移
  transferAccount: data => {
    return axios({
      url: '/huizb-app/myColleague/transferAccount',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 删除同事
  deleteColleague: data => {
    return axios({
      url: '/huizb-app/myColleague/deleteColleague',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
}
export default personCenter